<template>
    <div id="itembank-form" class="pb-10">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Bank Soal',
                    to: {
                        path: '/items',
                        query: { mapel: $route.query.mapel },
                    },
                    exact: true,
                },
                { text: !$route.query.id ? 'Tambah Soal Baru' : 'Ubah Soal' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ !$route.query.id ? "Tambah Soal Baru" : "Ubah Soal" }}
        </h3>

        <v-card>
            <v-card-title v-if="$route.query.id">Edit Soal</v-card-title>
            <v-card-title v-if="!$route.query.id">Tambah Soal</v-card-title>

            <v-divider></v-divider>
            <v-card-text>
                <v-list-item two-line class="px-0 pt-0 pb-4">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Mata Pelajaran *
                        </v-list-item-title>

                        <v-select
                            placeholder="Pilih Mata Pelajaran"
                            outlined
                            class="pa-0"
                            v-model="form.mapel"
                            :items="mapelList"
                            item-text="nama"
                            item-value="id"
                            @change="onMapelChanged"
                        ></v-select>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Jenjang *
                        </v-list-item-title>

                        <v-radio-group
                            class="ma-0"
                            row
                            v-model="form.jenjang"
                            @change="resetGrades()"
                        >
                            <v-radio
                                v-bind:key="level.id"
                                v-for="level in levels"
                                :value="level.id"
                                :label="level.nama"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                        </v-radio-group>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Kelas *
                        </v-list-item-title>
                        <div v-if="form.jenjang === 1" class="d-inline">
                            <v-checkbox
                                label="4"
                                :value="4"
                                v-model="grades"
                                class="pa-2 ma-0 d-inline-flex"
                                outlined
                            />
                            <v-checkbox
                                label="5"
                                :value="5"
                                v-model="grades"
                                class="pa-2 ma-0 d-inline-flex"
                                outlined
                            />
                            <v-checkbox
                                label="6"
                                :value="6"
                                v-model="grades"
                                class="pa-2 ma-0 d-inline-flex"
                                outlined
                            />
                        </div>
                        <div v-if="form.jenjang === 2" class="d-inline">
                            <v-checkbox
                                label="7"
                                :value="7"
                                v-model="grades"
                                class="pa-2 ma-0 d-inline-flex"
                                outlined
                            />
                            <v-checkbox
                                label="8"
                                :value="8"
                                v-model="grades"
                                class="pa-2 ma-0 d-inline-flex"
                                outlined
                            />
                            <v-checkbox
                                label="9"
                                :value="9"
                                v-model="grades"
                                class="pa-2 ma-0 d-inline-flex"
                                outlined
                            />
                        </div>
                        <div v-if="form.jenjang === 3" class="d-inline">
                            <v-checkbox
                                label="10"
                                :value="10"
                                v-model="grades"
                                class="pa-2 ma-0 d-inline-flex"
                                outlined
                            />
                            <v-checkbox
                                label="11"
                                :value="11"
                                v-model="grades"
                                class="pa-2 ma-0 d-inline-flex"
                                outlined
                            />
                            <v-checkbox
                                label="12"
                                :value="12"
                                v-model="grades"
                                class="pa-2 ma-0 d-inline-flex"
                                outlined
                            />
                        </div>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="px-0 pt-0 pb-4">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Jenis *
                        </v-list-item-title>

                        <v-select
                            placeholder="Pilih Jenis"
                            outlined
                            class="pa-0"
                            v-model="form.jenis"
                            :items="types"
                            item-text="nama"
                            item-value="id"
                        ></v-select>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Topik *
                        </v-list-item-title>

                        <app-autocomplete
                            placeholder="Cari Bab / (Sub) Sub Bab"
                            :data="topics"
                            v-on:selected="assignTopic($event)"
                            :value="form.topic"
                            :topic="
                                form.subSubBabId
                                    ? form.subSubBabId
                                    : form.subBabId
                                    ? form.subBabId
                                    : form.babId
                            "
                        ></app-autocomplete>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Label
                        </v-list-item-title>
                        <v-combobox
                            placeholder="Catatan soal"
                            :items="labels"
                            @keyup="form.label = form.label.toUpperCase()"
                            :search-input.sync="form.label"
                            outlined
                            maxlength="255"
                        ></v-combobox>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Sumber
                        </v-list-item-title>
                        <v-text-field
                            placeholder="Sumber"
                            v-model="form.sumber"
                            outlined
                        />
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Bank Soal
                        </v-list-item-title>
                        <v-checkbox
                            label="Tidak dimunculkan"
                            v-model="form.is_restricted"
                            class="pa-0 ma-0"
                            outlined
                        />
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pt-2">
                            Tingkat Kesulitan *
                        </v-list-item-title>

                        <v-radio-group row v-model="form.difficulty_level">
                            <v-radio
                                id="difficulty_level_lots"
                                label="LOTS"
                                value="LOTS"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                            <v-radio
                                id="difficulty_level_mots"
                                label="MOTS"
                                value="MOTS"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                            <v-radio
                                id="difficulty_level_hots"
                                label="HOTS"
                                value="HOTS"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                        </v-radio-group>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pt-5">
                            Tipe Pilihan *
                        </v-list-item-title>

                        <v-radio-group row v-model="form.selection_type">
                            <v-radio
                                id="selection_type_single"
                                label="Tunggal"
                                value="single"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                            <v-radio
                                id="selection_type_multiple"
                                label="Banyak"
                                value="multiple"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                            <v-radio
                                id="selection_type_choice"
                                label="Benar/Salah"
                                value="truefalse"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                            <v-radio
                                id="selection_type_inputtext"
                                label="Isian Singkat"
                                value="inputtext"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                        </v-radio-group>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Wacana
                        </v-list-item-title>
                        <app-wacana
                            ref="wacanaComp"
                            :mapel="form.mapel"
                            v-on:selected="form.wacana = $event"
                            :value="form.wacana"
                        ></app-wacana>
                    </v-list-item-content>
                </v-list-item>
            </v-card-text>
        </v-card>

        <v-card
            v-if="form.selection_type != 'inputtext'"
            plain
            class="pa-0 my-4"
        >
            <v-card-title class="text-subtitle-1 font-weight-bold">
                Soal & Jawaban *
                <v-spacer></v-spacer>
                <v-btn
                    :disabled="
                        form.opsiA == '' || form.opsiB == '' || form.soal == ''
                    "
                    color="backgroundGreen"
                    class="darkGreen--text"
                    @click="getPreview()"
                    elevation="0"
                >
                    Preview
                </v-btn>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-col cols="8">
                    <v-card flat color="#f0f3f9">
                        <v-card-text
                            class="font-weight-600 mb-5 align-center d-flex"
                            style="color: #0e97d6"
                        >
                            <v-icon class="mr-2" color="primary">
                                mdi-information
                            </v-icon>

                            Jumlah pilihan jawaban menyesuaikan dengan value
                            jawaban yang diisi
                        </v-card-text>
                    </v-card>

                    <app-editor
                        v-on:content-updated="form.soal = $event"
                        :value="form.soal"
                        :context="mapel"
                        :hasUpload="true"
                        title="Soal *"
                        @preview="showModalAppEditor($event)"
                    ></app-editor>
                </v-col>
                <v-col cols="8">
                    <v-card
                        plain
                        class="d-flex"
                        color="#ECEFF5"
                        v-bind:class="{
                            'has-error': errors.indexOf('opsiA') >= 0,
                        }"
                    >
                        <div
                            cols="1"
                            class="px-4 py-3 d-flex align-center justify-center black60--text"
                        >
                            <span class="text-subtitle-2 font-weight-bold"
                                >A</span
                            >
                        </div>

                        <app-editor
                            class="pa-0 ma-0 flex-grow-1"
                            v-on:content-updated="form.opsiA = $event"
                            v-on:status-updated="form.answerA = $event"
                            :value="form.opsiA"
                            :answer="form.answerA"
                            :context="mapel"
                            :hasUpload="true"
                            title="Jawaban *"
                            type="jawaban"
                            @preview="showModalAppEditor($event)"
                        ></app-editor>
                    </v-card>
                </v-col>
                <v-col cols="8">
                    <v-card
                        plain
                        class="d-flex"
                        color="#ECEFF5"
                        v-bind:class="{
                            'has-error': errors.indexOf('opsiB') >= 0,
                        }"
                    >
                        <div
                            cols="1"
                            class="px-4 py-3 d-flex align-center justify-center black60--text"
                        >
                            <span class="text-subtitle-2 font-weight-bold"
                                >B</span
                            >
                        </div>

                        <app-editor
                            class="pa-0 ma-0 flex-grow-1"
                            v-on:content-updated="form.opsiB = $event"
                            v-on:status-updated="form.answerB = $event"
                            :value="form.opsiB"
                            :context="mapel"
                            :hasUpload="true"
                            :answer="form.answerB"
                            title="Jawaban *"
                            type="jawaban"
                            @preview="showModalAppEditor($event)"
                        ></app-editor>
                    </v-card>
                </v-col>
                <v-col cols="8">
                    <v-card
                        plain
                        class="d-flex"
                        color="#ECEFF5"
                        v-bind:class="{
                            'has-error': errors.indexOf('opsiC') >= 0,
                        }"
                    >
                        <div
                            cols="1"
                            class="px-4 py-3 d-flex align-center justify-center black60--text"
                        >
                            <span class="text-subtitle-2 font-weight-bold"
                                >C</span
                            >
                        </div>

                        <app-editor
                            class="pa-0 ma-0 flex-grow-1"
                            v-on:content-updated="form.opsiC = $event"
                            v-on:status-updated="form.answerC = $event"
                            :value="form.opsiC"
                            :answer="form.answerC"
                            :context="mapel"
                            :hasUpload="true"
                            title="Jawaban"
                            type="jawaban"
                            @preview="showModalAppEditor($event)"
                        ></app-editor>
                    </v-card>
                </v-col>
                <v-col cols="8">
                    <v-card
                        plain
                        class="d-flex"
                        color="#ECEFF5"
                        v-bind:class="{
                            'has-error': errors.indexOf('opsiD') >= 0,
                        }"
                    >
                        <div
                            cols="1"
                            class="px-4 py-3 d-flex align-center justify-center black60--text"
                        >
                            <span class="text-subtitle-2 font-weight-bold"
                                >D</span
                            >
                        </div>

                        <app-editor
                            class="pa-0 ma-0 flex-grow-1"
                            v-on:content-updated="form.opsiD = $event"
                            v-on:status-updated="form.answerD = $event"
                            :value="form.opsiD"
                            :context="mapel"
                            :hasUpload="true"
                            :answer="form.answerD"
                            title="Jawaban"
                            type="jawaban"
                            @preview="showModalAppEditor($event)"
                        ></app-editor>
                    </v-card>
                </v-col>
                <v-col cols="8">
                    <span>Opsional</span>
                    <v-card plain class="d-flex mt-3" color="#ECEFF5">
                        <div
                            cols="1"
                            class="px-4 py-3 d-flex align-center justify-center black60--text"
                        >
                            <span class="text-subtitle-2 font-weight-bold"
                                >E</span
                            >
                        </div>

                        <app-editor
                            class="pa-0 ma-0 flex-grow-1"
                            v-on:content-updated="form.opsiE = $event"
                            v-on:status-updated="form.answerE = $event"
                            :value="form.opsiE"
                            :context="mapel"
                            :hasUpload="true"
                            :answer="form.answerE"
                            title="Jawaban"
                            type="jawaban"
                            @preview="showModalAppEditor($event)"
                        ></app-editor>
                    </v-card>
                </v-col>
                <v-col cols="8">
                    <app-editor
                        v-on:content-updated="form.pembahasan = $event"
                        :value="form.pembahasan"
                        :context="mapel"
                        :hasUpload="true"
                        title="Pembahasan"
                        @preview="showModalAppEditor($event)"
                    ></app-editor>
                </v-col>
                <v-col
                    cols="8"
                    v-bind:class="{
                        'has-error': errors.indexOf('jawaban') >= 0,
                    }"
                >
                    <v-list-item two-line class="pa-0">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title class="font-weight-bold pb-2">
                                Jawaban *
                            </v-list-item-title>

                            <v-radio-group
                                class="ma-0"
                                row
                                v-model="form.jawaban"
                            >
                                <v-radio
                                    value="A"
                                    label="A"
                                    class="jenjang-selection"
                                    active-class="act-radio-btn"
                                ></v-radio>
                                <v-radio
                                    value="B"
                                    label="B"
                                    class="jenjang-selection"
                                    active-class="act-radio-btn"
                                ></v-radio>
                                <v-radio
                                    value="C"
                                    label="C"
                                    class="jenjang-selection"
                                    active-class="act-radio-btn"
                                ></v-radio>
                                <v-radio
                                    value="D"
                                    label="D"
                                    class="jenjang-selection"
                                    active-class="act-radio-btn"
                                ></v-radio>
                                <v-radio
                                    value="E"
                                    label="E"
                                    class="jenjang-selection"
                                    active-class="act-radio-btn"
                                ></v-radio>
                            </v-radio-group>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="12">
                    <v-list-item two-line class="pa-0">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title class="font-weight-bold pb-2">
                                Eigen
                            </v-list-item-title>

                            <v-text-field
                                placeholder="2.55"
                                type="number"
                                step="any"
                                v-model="form.eigen"
                                outlined
                            />
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-list-item two-line>
                    <v-list-item-content class="pt-0 px-0 pb-6">
                        <v-list-item-title class="font-weight-bold pb-2">
                            User Group
                        </v-list-item-title>
                        <v-autocomplete
                            :items="user_groups"
                            item-text="user_group_name"
                            item-value="id"
                            class="pb-2"
                            placeholder="-- Pilih user group --"
                            outlined
                            v-for="(usgr, i) in form.user_group"
                            :key="i"
                            v-model="form.user_group[i]"
                        >
                            <template v-slot:append-outer>
                                <v-btn
                                    id="user-remove-scope-btn"
                                    dark
                                    x-large
                                    class="font-weight-bold dark--text py-3"
                                    depressed
                                    color="white"
                                    elevation="1"
                                    v-if="
                                        i === form.user_group.length - 1 &&
                                        form.user_group.length != 1
                                    "
                                    @click="
                                        queryId
                                            ? null
                                            : form.user_group.splice(i, 1)
                                    "
                                >
                                    Hapus
                                </v-btn>
                            </template>
                        </v-autocomplete>
                    </v-list-item-content>
                </v-list-item>
                <v-container>
                    <v-btn
                        id="user-add-scope-btn"
                        @click="form.user_group.push('')"
                        block
                        depressed
                        class="font-weight-bold blew--text mb-5"
                        color="#e8f5fa"
                    >
                        <v-icon style="font-size: 16px !important" class="mr-1">
                            mdi-plus-circle
                        </v-icon>
                        Tambah User Group Baru
                    </v-btn>
                </v-container>
            </v-card-text>
        </v-card>

        <v-card
            v-if="form.selection_type === 'inputtext'"
            plain
            class="pa-0 my-4"
        >
            <v-card-title class="text-subtitle-1 font-weight-bold">
                Soal & Jawaban *
                <v-spacer></v-spacer>
                <v-btn
                    :disabled="form.jawaban == '' || form.soal == ''"
                    color="backgroundGreen"
                    class="darkGreen--text"
                    @click="getPreview()"
                    elevation="0"
                >
                    Preview
                </v-btn>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-col cols="8">
                    <app-editor
                        v-on:content-updated="form.soal = $event"
                        :value="form.soal"
                        :context="mapel"
                        :hasUpload="true"
                        title="Soal *"
                        @preview="showModalAppEditor($event)"
                    ></app-editor>
                </v-col>
                <v-col cols="8"
                    ><input
                        type="text"
                        disabled
                        placeholder="Isian Jawaban"
                        class="form-control input-lg"
                /></v-col>

                <v-col
                    v-if="showTambahKalimat === true && form.soalTambah === ''"
                    cols="8"
                >
                    <v-btn
                        id="user-add-scope-btn"
                        @click="showTambahKalimatButton()"
                        block
                        class="font-weight-bold dark--text"
                        color="white"
                    >
                        <v-icon style="font-size: 16px !important"
                            >mdi-plus-circle</v-icon
                        >
                        Tambah Kalimat
                    </v-btn>
                </v-col>

                <v-col
                    v-if="addSoal === true || form.soalTambah != ''"
                    cols="8"
                >
                    <app-editor
                        v-on:content-updated="form.soalTambah = $event"
                        :value="form.soalTambah"
                        :context="mapel"
                        :hasUpload="true"
                        title="Soal"
                        @preview="showModalAppEditor($event)"
                    ></app-editor>
                </v-col>

                <v-col cols="8">
                    <app-editor
                        v-on:content-updated="form.pembahasan = $event"
                        :value="form.pembahasan"
                        :context="mapel"
                        :hasUpload="true"
                        title="Pembahasan"
                        @preview="showModalAppEditor($event)"
                    ></app-editor>
                </v-col>

                <v-col cols="8">
                    <v-list-item two-line class="pa-0">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title class="font-weight-bold pb-2">
                                Jawaban *
                            </v-list-item-title>
                            <v-text-field
                                placeholder="Jawaban"
                                v-model="form.jawaban"
                                outlined
                            />
                        </v-list-item-content>
                    </v-list-item>
                </v-col>

                <v-col cols="12">
                    <v-list-item two-line class="pa-0">
                        <v-list-item-content class="pa-0">
                            <v-list-item-title class="font-weight-bold pb-2">
                                Eigen
                            </v-list-item-title>

                            <v-text-field
                                placeholder="2.55"
                                type="number"
                                step="any"
                                v-model="form.eigen"
                                outlined
                            />
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-list-item two-line>
                    <v-list-item-content class="pt-0 px-0 pb-6">
                        <v-list-item-title class="font-weight-bold pb-2">
                            User Group
                        </v-list-item-title>
                        <v-autocomplete
                            :items="user_groups"
                            item-text="user_group_name"
                            item-value="id"
                            class="pb-2"
                            placeholder="-- Pilih user group --"
                            outlined
                            v-for="(usgr, i) in form.user_group"
                            :key="i"
                            v-model="form.user_group[i]"
                        >
                            <template v-slot:append-outer>
                                <v-btn
                                    id="user-remove-scope-btn"
                                    dark
                                    x-large
                                    class="font-weight-bold dark--text py-3"
                                    depressed
                                    color="white"
                                    elevation="1"
                                    v-if="
                                        i === form.user_group.length - 1 &&
                                        form.user_group.length != 1
                                    "
                                    @click="
                                        queryId
                                            ? null
                                            : form.user_group.splice(i, 1)
                                    "
                                >
                                    Hapus
                                </v-btn>
                            </template>
                        </v-autocomplete>
                    </v-list-item-content>
                </v-list-item>
                <v-container>
                    <v-btn
                        id="user-add-scope-btn"
                        @click="form.user_group.push('')"
                        block
                        depressed
                        class="font-weight-bold blew--text mb-5"
                        color="#e8f5fa"
                    >
                        <v-icon style="font-size: 16px !important" class="mr-1">
                            mdi-plus-circle
                        </v-icon>
                        Tambah User Group Baru
                    </v-btn>
                </v-container>
            </v-card-text>
        </v-card>

        <v-row class="pa-4">
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                large
                :loading="loading"
                @click="saveItembank()"
            >
                Simpan
            </v-btn>
        </v-row>

        <v-dialog
            v-model="showModal"
            v-if="showModal"
            transition="dialog-top-transition"
            width="360px"
            min-height="537px"
            max-height="771px"
            @click:outside="showModal = false"
            scrollable
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title class="d-flex" width="100%">
                        Preview Soal
                        <v-spacer></v-spacer>
                        <v-btn icon small @click="dialog.value = false">
                            <v-icon>mdi-close-circle</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="pa-0" width="100%">
                        <v-card flat color="#f3f5f7" class="py-2">
                            <v-card
                                v-if="preview.wacana"
                                flat
                                class="ma-0 mb-2"
                            >
                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            class="text-body-2 black--text"
                                        >
                                            <p
                                                v-if="!!form.wacana"
                                                style="white-space: pre-line"
                                                v-html="previewWacana"
                                            ></p>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card>
                            <v-card flat class="mx-0 mb-2">
                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            class="text-body-2 black--text"
                                        >
                                            <div
                                                style="white-space: pre-line"
                                                v-html="
                                                    parseLatex(preview.soal)
                                                "
                                            ></div>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card>
                            <v-card
                                v-if="form.selection_type != 'inputtext'"
                                flat
                                class="mx-0 my-2"
                            >
                                <v-list>
                                    <v-list-item
                                        two-line
                                        style="min-height: none !important"
                                    >
                                        <v-list-item-content>
                                            <v-list-item-title
                                                class="font-weight-bold black--text pa-0"
                                            >
                                                Pilihan Jawaban
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-card
                                        v-if="
                                            form.selection_type === 'single' ||
                                            form.selection_type === 'multiple'
                                        "
                                        v-for="(jawaban, i) in preview.pilihan"
                                        :key="i"
                                        v-show="jawaban.value"
                                        elevation="0"
                                        class="mx-4 my-2"
                                        color="#ECEFF5"
                                    >
                                        <div
                                            cols="1"
                                            class="pa-2 d-flex align-center"
                                            :class="
                                                jawaban.answer === true
                                                    ? 'bg-success text-white'
                                                    : 'black60--text'
                                            "
                                        >
                                            <span
                                                class="text-subtitle-1 font-weight-bold px-2"
                                            >
                                                {{ jawaban.key }}
                                            </span>
                                            <div
                                                v-html="
                                                    parseLatex(jawaban.value)
                                                "
                                            ></div>
                                        </div>
                                    </v-card>

                                    <div
                                        class="mx-4 my-2 mb-4"
                                        v-if="
                                            form.selection_type === 'truefalse'
                                        "
                                    >
                                        <table width="100%" cellpadding="10">
                                            <tr
                                                style="
                                                    background-color: #f3f5f7;
                                                "
                                            >
                                                <td width="60%" class="pa-3">
                                                    Pernyataan
                                                </td>
                                                <td class="pa-3" align="center">
                                                    Benar
                                                </td>
                                                <td class="pa-3" align="center">
                                                    Salah
                                                </td>
                                            </tr>
                                            <tr
                                                v-for="(
                                                    jawaban, i
                                                ) in preview.pilihan"
                                                style="
                                                    border-top: 1px solid
                                                        #ebebeb;
                                                "
                                                v-show="jawaban.value"
                                            >
                                                <td class="pa-3" width="40%">
                                                    <div
                                                        v-html="
                                                            parseLatex(
                                                                jawaban.value
                                                            )
                                                        "
                                                    ></div>
                                                </td>
                                                <td
                                                    class="pa-3 text-center"
                                                    :class="
                                                        jawaban.answer === true
                                                            ? 'bg-success text-white'
                                                            : 'bg-error'
                                                    "
                                                >
                                                    <v-icon
                                                        v-if="jawaban.answer"
                                                        color="white"
                                                        style="font-size: 20px"
                                                    >
                                                        mdi-check-circle
                                                    </v-icon>
                                                </td>

                                                <td
                                                    class="pa-3 text-center"
                                                    :class="
                                                        !jawaban.answer
                                                            ? 'bg-success text-white'
                                                            : 'bg-error'
                                                    "
                                                >
                                                    <v-icon
                                                        v-if="!jawaban.answer"
                                                        color="white"
                                                        style="font-size: 20px"
                                                    >
                                                        mdi-check-circle
                                                    </v-icon>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </v-list>
                            </v-card>

                            <v-card
                                v-if="form.selection_type === 'inputtext'"
                                flat
                                class="mx-0 my-2"
                            >
                                <v-list>
                                    <v-list-item
                                        two-line
                                        style="min-height: none !important"
                                    >
                                        <v-list-item-content>
                                            <v-list-item-subtitle
                                                class="font-weight-bold black--text pa-0"
                                            >
                                                Jawaban
                                            </v-list-item-subtitle>
                                            <div
                                                v-html="parseLatex(preview.key)"
                                            ></div>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card>

                            <v-card flat class="mx-0 my-2">
                                <v-list>
                                    <v-list-item
                                        two-line
                                        style="min-height: none !important"
                                    >
                                        <v-list-item-content>
                                            <v-list-item-subtitle
                                                class="font-weight-bold black--text pa-0"
                                            >
                                                Pembahasan
                                            </v-list-item-subtitle>

                                            <v-list-item-title
                                                class="text-body-2 black--text"
                                                v-html="
                                                    parseLatex(
                                                        preview.explanation
                                                    )
                                                "
                                            ></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card>
                        </v-card>
                    </v-card-text>
                </v-card>
            </template>
        </v-dialog>

        <v-dialog
            v-model="showModalEditor"
            width="520"
            @click:outside="showModalEditor = false"
            scrollable
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title>Preview {{ title }}</v-card-title>

                    <v-card-text
                        width="100%"
                        class="py-5"
                        v-html="parseLatex(app_editor_val)"
                    >
                    </v-card-text>

                    <v-card-actions class="justify-end">
                        <v-btn
                            dark
                            color="blew"
                            elevation="0"
                            @click="dialog.value = false"
                            >Tutup</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
    </div>
</template>

<script>
import Autocomplete from "@/modules/global/components/plugins/Autocomplete";
import axios from "axios";
import itembankService from "@/modules/itembank/services/itembank.js";
import katex from "katex";
import LabelAutocomplete from "@/modules/global/components/plugins/LabelAutocomplete";
import MarkdownEditor from "@/modules/global/components/plugins/MarkdownEditor-c";
import Marked from "marked";
import showdown from "showdown";
import Wacana from "@/modules/itembank/components/Wacana";

export default {
    name: "itembank-form",

    components: {
        "app-autocomplete": Autocomplete,
        "app-editor": MarkdownEditor,
        "app-labelAutocomplete": LabelAutocomplete,
        "app-wacana": Wacana,
    },

    data: function () {
        var mapelId = this.$route.query.mapel;
        var mapels = JSON.parse(localStorage.getItem("mapels"));
        var found = mapels.find(function (element) {
            return element.id == mapelId;
        });

        return {
            loadingPreview: true,
            loading: false,
            compiledContent: "",
            labelQuery: "",
            labels: [],
            mapel: found.nama,
            types: [],
            levels: [],
            topics: [],
            errors: [],
            grades: [],
            preview: {},
            mapels: [],
            kodeSoal: null,
            showModal: false,
            showModalEditor: false,
            imgLocation: "",
            showPreview: {
                isShow: false,
                title: "",
                content: "",
            },
            form: {
                id: 0,
                wacana: null,
                mapel: null,
                mapelId: this.$route.query.mapel,
                sumber: "",
                topic: "",
                jenjang: 3,
                grades: [],
                jenis: 1,
                babId: 0,
                subBabId: 0,
                subSubBabId: 0,
                soal: "",
                soalTambah: "",
                opsiA: "",
                opsiB: "",
                opsiC: "",
                opsiD: "",
                opsiE: "",
                answerA: false,
                answerB: false,
                answerC: false,
                answerD: false,
                answerE: false,
                jawaban: "",
                pembahasan: "",
                is_restricted: false,
                label: "",
                eigen: 0.0,
                sumber: "",
                pembahasan: "",
                difficulty_level: "",
                selection_type: "",
                user_group: [],
            },
            error_selection_type: null,
            user_group: [],
            addSoal: false,
            showTambahKalimat: true,
            mapelList: JSON.parse(localStorage.getItem("mapels")),
        };
    },

    watch: {
        grades: function (val) {
            this.form.grades = val;
        },
    },

    mounted: function () {
        var context = this;
        this.labelData();
        this.getUserGroupData();

        itembankService.getListOfItemType(function (result) {
            if (result.success) {
                context.types = result.data;
            }
        });

        itembankService.getListOfSchoolGrade(function (result) {
            if (result.success) {
                context.levels = result.data;
            }
        });

        if (this.$route.query.id) {
            this.loadingPreview = true;
            this.form.id = this.$route.query.id;
            var context = this;
            itembankService.getItemById(this.form.id, function (result) {
                if (result.success) {
                    var item = result.data;
                    context.form.mapel =
                        parseInt(context.$route.query.mapel) ||
                        item.bab.mapel_id;
                    context.form.jenjang = item.jenjang.id;
                    context.form.jenis = item.jenis_soal.id;
                    context.form.sumber = item.sumber;
                    context.form.soal = item.isi;
                    context.form.opsiA = item.pilihan_1;
                    context.form.opsiB = item.pilihan_2;
                    context.form.opsiC = item.pilihan_3;
                    context.form.opsiD = item.pilihan_4;
                    context.form.opsiE = item.pilihan_5;
                    context.form.jawaban = item.jawaban;
                    context.form.eigen = item.nilai_eigen;
                    context.form.pembahasan = item.pembahasan;
                    context.form.is_restricted = item.is_restricted;
                    context.form.label = item.label;
                    context.kodeSoal = item.kode;
                    context.form.difficulty_level = item.difficulty_level;

                    context.form.selection_type = item.tipe_pilihan;

                    if (context.form.selection_type === "inputtext") {
                        const newSoal = context.form.soal.split(
                            '<input type="text" id="inputAnswer" />'
                        );

                        context.form.soal = newSoal[0];
                        context.form.soalTambah = newSoal[1];
                    }

                    context.form.answerA = item.st_pilihan_1;
                    context.form.answerB = item.st_pilihan_2;
                    context.form.answerC = item.st_pilihan_3;
                    context.form.answerD = item.st_pilihan_4;
                    context.form.answerE = item.st_pilihan_5;

                    item.grades.forEach(function (grade) {
                        context.grades.push(grade.grade);
                    });

                    context.form.grades = context.grades;
                    if (item.wacana)
                        context.form.wacana = {
                            id: item.wacana.id,
                            content: item.wacana.isi,
                        };

                    if (item.bab) {
                        context.form.babId = item.bab.id;
                        context.form.topic += item.bab.nama;
                    }

                    if (item.sub_bab) {
                        context.form.subBabId = item.sub_bab.id;
                        context.form.topic += " >> " + item.sub_bab.nama;
                    }

                    if (item.sub_sub_bab) {
                        context.form.subSubBabId = item.sub_sub_bab.id;
                        context.form.topic += " >> " + item.sub_sub_bab.nama;
                    }

                    var userGroup = [];
                    if (item.user_groups.length > 0) {
                        for (var i = 0; i < item.user_groups.length; i++) {
                            userGroup.push(item.user_groups[i].id);
                        }
                    }

                    context.form.user_group = userGroup;

                    document.title =
                        item.bab && item.sub_bab
                            ? item.bab.nama + " (" + item.sub_bab.nama + ")"
                            : "Skolla Admin";
                }
                context.loadingPreview = false;

                context.getTopics();
            });
        }
    },

    methods: {
        getMapelById: function (mapelId) {
            var mapel = JSON.parse(localStorage.getItem("mapels"));
            var found = mapel.find(function (element) {
                return element.id == mapelId;
            });

            return found;
        },

        getPreview() {
            var context = this;
            context.showModal = true;
            // if (context.form.selection_type === "inputtext") {
            //     context.form.soal =
            //         context.form.soal +
            //         '<input type="text" id="inputAnswer" />' +
            //         context.form.soalTambah;
            // }

            const preview = {
                explanation: context.form.pembahasan
                    ? context.form.pembahasan
                    : "",
                item_code: context.kodeSoal,
                key: context.form.jawaban,
                pilihan: [
                    {
                        key: "A",
                        value: context.form.opsiA ? context.form.opsiA : "",
                        answer: context.form.answerA
                            ? context.form.answerA
                            : "",
                    },
                    {
                        key: "B",
                        value: context.form.opsiB ? context.form.opsiB : "",
                        answer: context.form.answerB
                            ? context.form.answerB
                            : "",
                    },
                    {
                        key: "C",
                        value: context.form.opsiC ? context.form.opsiC : "",
                        answer: context.form.answerC
                            ? context.form.answerC
                            : "",
                    },
                    {
                        key: "D",
                        value: context.form.opsiD ? context.form.opsiD : "",
                        answer: context.form.answerD
                            ? context.form.answerD
                            : "",
                    },
                    {
                        key: "E",
                        value: context.form.opsiE ? context.form.opsiE : "",
                        answer: context.form.answerE
                            ? context.form.answerE
                            : "",
                    },
                ],
                soal: context.form.soal,
                wacana: context.form.wacana ? context.form.wacana.content : "",
                jawaban: context.form.jawaban,
            };
            this.preview = preview;

            context.loadingPreview = false;
        },

        saveItembank() {
            var context = this;

            if (this.validateForm()) {
                if (!this.validateSelectionType()) {
                    context.$store.commit("showAlert", {
                        message: context.error_selection_type,
                        type: "error",
                    });
                    return false;
                }

                this.loading = true;
                if (this.form.selection_type === "inputtext") {
                    this.form.soal =
                        this.form.soal +
                        '<input type="text" id="inputAnswer" />' +
                        this.form.soalTambah;
                }

                context.form.mapel = parseInt(context.form.mapel);

                if (!this.form.id) {
                    itembankService.createItem(this.form, function (result) {
                        if (result.success) {
                            context.$store.commit("showAlert", {
                                message: `Berhasil Menyimpan Data!`,
                                type: "success",
                            });
                            context.$router.push({
                                path: "/items",
                                query: { mapel: context.$route.query.mapel },
                            });
                        } else {
                            context.$store.commit("showAlert", {
                                message: `Terjadi kesalahan, soal tidak dapat di update untuk saat ini`,
                                type: "error",
                            });
                        }
                        context.loading = false;
                    });
                } else {
                    itembankService.updateItem(
                        this.form.id,
                        this.form,
                        function (result) {
                            if (result.success) {
                                context.$store.commit("showAlert", {
                                    message: `Berhasil Menyimpan Data!`,
                                    type: "success",
                                });
                                context.$router.push({
                                    path: "/items",
                                    query: {
                                        mapel: context.$route.query.mapel,
                                    },
                                });
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Terjadi kesalahan, tidak dapat mengupdate soal untuk saat ini`,
                                    type: "error",
                                });
                            }
                            context.loading = false;
                        }
                    );
                }
            }
        },

        validateForm: function () {
            var err = false;

            if (!this.form.mapel) {
                this.$store.commit("showAlert", {
                    message: `Mata pelajaran wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.form.jenjang) {
                this.$store.commit("showAlert", {
                    message: `Jenjang wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (this.grades.length === 0) {
                this.$store.commit("showAlert", {
                    message: `Kelas wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.form.jenis) {
                this.$store.commit("showAlert", {
                    message: `Jenis wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.form.babId) {
                this.$store.commit("showAlert", {
                    message: `Topik wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.form.babId) {
                this.$store.commit("showAlert", {
                    message: `Topic wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.form.soal) {
                this.$store.commit("showAlert", {
                    message: `Soal wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (
                !this.form.opsiA &&
                this.form.selection_type != "inputtext"
            ) {
                this.$store.commit("showAlert", {
                    message: `Opsi A wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (
                !this.form.opsiB &&
                this.form.selection_type != "inputtext"
            ) {
                this.$store.commit("showAlert", {
                    message: `Opsi B wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.form.difficulty_level) {
                this.$store.commit("showAlert", {
                    message: `Tingkat Kesulitan wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (
                this.form.jawaban === "E" &&
                !this.form.opsiE &&
                this.form.selection_type != "inputtext"
            ) {
                this.$store.commit("showAlert", {
                    message: `Anda memilih jawaban E, Opsi E wajib diisi!`,
                    type: "error",
                });
                err = true;
            }
            // else if (!this.form.jawaban && this.form.selection_type != 'inputtext') {
            //   this.$store.commit("showAlert", {
            //     message: `Jawaban wajib diisi!`,
            //     type: "error",
            //   });
            //   err = true;
            // }
            return !err;
        },

        assignTopic: function (result) {
            var topicIds = result.data;
            this.form.babId = topicIds[0];
            this.form.subBabId = topicIds[1];
            this.form.subSubBabId = topicIds[2];
            this.form.topic = result.text;
        },

        onLabelSelected: function (label) {
            this.form.label = label;
            this.labelQuery = "";
        },

        resetGrades: function () {
            this.grades = [];
        },

        showModalAppEditor(val) {
            this.app_editor_val = val;
            this.showModalEditor = true;
        },

        parseLatex: function (content) {
            var converter = new showdown.Converter();

            var compiledContent = content.replace(/&gt;/g, ">");
            compiledContent = compiledContent.replace(/&lt;/g, "<");
            compiledContent = compiledContent.replace(/&amp;/g, "&");

            // alert(compiledContent)
            compiledContent = this.compileInlineLatex(compiledContent);
            compiledContent = this.compileBlockLatex(compiledContent);

            return converter.makeHtml(compiledContent);
        },

        compileInlineLatex: function (content) {
            var pattern = /\\\\\((.*?)\\\\\)/g;
            var compiledContent = content;
            var match;

            // eslint-disable-next-line
            while ((match = pattern.exec(compiledContent))) {
                var index = match.index;
                var length = match[0].length;
                var formula = katex.renderToString(match[1], { trust: true });
                compiledContent =
                    compiledContent.substr(0, index) +
                    formula +
                    compiledContent.substr(index + length);
            }

            return compiledContent;
        },

        compileBlockLatex: function (content) {
            var pattern = /\$\$(.*?)\$\$/g;
            var compiledContent = content;
            var match;

            // eslint-disable-next-line
            while ((match = pattern.exec(compiledContent))) {
                var index = match.index;
                var length = match[0].length;
                var formula =
                    '<p class="text-center">' +
                    katex.renderToString(match[1], { trust: true }) +
                    "</p>";
                compiledContent =
                    compiledContent.substr(0, index) +
                    formula +
                    compiledContent.substr(index + length);
            }

            return compiledContent;
        },

        labelData: function () {
            if (this.labels.length == 0) {
                this.labels = [];
                var url = process.env.API_BASE_URL + "/itembank/labels";
                var authToken = JSON.parse(localStorage.getItem("token")).value;
                var options = {
                    headers: {
                        Authorization: "Bearer " + authToken,
                    },
                };

                var context = this;
                axios.get(url, options).then(function (response) {
                    if (response.status === 200) {
                        response.data.forEach(function (d) {
                            context.labels.push(d);
                        });
                    }
                });
            }
        },
        validateSelectionType() {
            var answer_total = 0;
            var validate = true;
            var context = this;

            context.error_selection_type = null;

            if (this.form.answerA) answer_total = answer_total + 1;
            if (this.form.answerB) answer_total = answer_total + 1;
            if (this.form.answerC) answer_total = answer_total + 1;
            if (this.form.answerD) answer_total = answer_total + 1;
            if (this.form.answerE) answer_total = answer_total + 1;

            if (context.form.selection_type === "single") {
                if (answer_total < 1) {
                    context.error_selection_type =
                        "Jawaban benar belum ada yang di pilih";
                    validate = false;
                } else if (answer_total > 1) {
                    context.error_selection_type =
                        "Untuk tipe pilihan tunggal, jawaban benar tidak boleh lebih dari 1";
                    validate = false;
                } else {
                    validate = true;
                }
            } else if (context.form.selection_type === "multiple") {
                if (answer_total < 1) {
                    context.error_selection_type =
                        "Jawaban benar belum ada yang di pilih";
                    validate = false;
                } else {
                    validate = true;
                }
            }

            return validate;
        },

        getUserGroupData() {
            this.user_groups = [];
            const url =
                process.env.API_BASE_URL +
                "/payment/list/user_group?page=1&per_page=1000";

            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };
            const context = this;
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.user_groups = response.data.user_groups;
                }
            });
        },

        showTambahKalimatButton() {
            this.addSoal = true;
            this.showTambahKalimat = false;
        },

        getTopics() {
            var context = this;
            var mapelId = this.form.mapel;
            var mapel = this.getMapelById(mapelId);

            itembankService.getListOfTopic(mapel.code, function (result) {
                context.topics = result.data;
            });
        },
        onMapelChanged() {
            // 1) update topics & reset dependent fields
            this.getTopics();
            this.form.topic = null;
            this.form.wacana = null;

            // 2) if child ref ada, panggil method publik di child untuk reload
            if (
                this.$refs.wacanaComp &&
                typeof this.$refs.wacanaComp.loadDataForMapel === "function"
            ) {
                this.$refs.wacanaComp.loadDataForMapel(this.form.mapel);
            }
        },
    },

    computed: {
        noPreview() {
            if (JSON.stringify(this.preview) === "{}") {
                return true;
            } else {
                return false;
            }
        },

        beforeMount: function () {},

        previewWacana: function () {
            return Marked(this.form.wacana.content);
        },
    },
};
</script>

<style scoped>
@import "https://cdn.jsdelivr.net/npm/katex@0.15.1/dist/katex.min.css";

.card {
    background-color: #fff;
    border: 1px solid transparent;
    border-radius: 6px;
}

.card > .card-link {
    color: #333;
}

.card > .card-link:hover {
    text-decoration: none;
}

.card > .card-link .card-img img {
    border-radius: 6px 6px 0 0;
}

.card .card-img {
    position: relative;
    padding: 0;
    display: table;
}

.card .card-img .card-caption {
    position: absolute;
    right: 0;
    bottom: 16px;
    left: 0;
}

.card .card-body {
    display: table;
    width: 100%;
    padding: 12px;
}

.card .card-header {
    border-radius: 6px 6px 0 0;
    padding: 8px;
}

.card .card-footer {
    border-radius: 0 0 6px 6px;
    padding: 8px;
}

.card .card-left {
    position: relative;
    float: left;
    padding: 0 0 8px 0;
}

.card .card-right {
    position: relative;
    float: left;
    padding: 8px 0 0 0;
}

.card .card-body h1:first-child,
.card .card-body h2:first-child,
.card .card-body h3:first-child,
.card .card-body h4:first-child,
.card .card-body .h1,
.card .card-body .h2,
.card .card-body .h3,
.card .card-body .h4 {
    margin-top: 0;
}

.card .card-body .heading {
    display: block;
}

.card .card-body .heading:last-child {
    margin-bottom: 0;
}

.card .card-body .lead {
    text-align: center;
}

@media (min-width: 768px) {
    .card .card-left {
        float: left;
        padding: 0 8px 0 0;
    }
    .card .card-right {
        float: left;
        padding: 0 0 0 8px;
    }

    .card .card-4-8 .card-left {
        width: 33.33333333%;
    }
    .card .card-4-8 .card-right {
        width: 66.66666667%;
    }

    .card .card-5-7 .card-left {
        width: 41.66666667%;
    }
    .card .card-5-7 .card-right {
        width: 58.33333333%;
    }

    .card .card-6-6 .card-left {
        width: 50%;
    }
    .card .card-6-6 .card-right {
        width: 50%;
    }

    .card .card-7-5 .card-left {
        width: 58.33333333%;
    }
    .card .card-7-5 .card-right {
        width: 41.66666667%;
    }

    .card .card-8-4 .card-left {
        width: 66.66666667%;
    }
    .card .card-8-4 .card-right {
        width: 33.33333333%;
    }
}

@media (max-width: 760px) {
    .modal-container {
        max-width: 100vw;
    }
}

.card-default {
    border-color: #ddd;
    background-color: #fff;
    margin-bottom: 24px;
}

.card-default > .card-header,
.card-default > .card-footer {
    color: #333;
    background-color: #ddd;
}

.card-default > .card-header {
    border-bottom: 1px solid #ddd;
    padding: 8px;
}

.card-default > .card-footer {
    border-top: 1px solid #ddd;
    padding: 8px;
}

.card-default > .card-img:first-child img {
    border-radius: 6px 6px 0 0;
}

.card-default > .card-left {
    padding-right: 4px;
}

.card-default > .card-right {
    padding-left: 4px;
}

.card-default p:last-child {
    margin-bottom: 0;
}

.card-default .card-caption {
    color: #fff;
    text-align: center;
    text-transform: uppercase;
}

.avatar {
    vertical-align: middle;
    text-align: center;
    color: white;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background-color: #666;
}

.pembahasan-parent >>> p img {
    max-width: 100%;
}

.modal-container {
    max-width: 425px;
}

.bg-success {
    background-color: #00cf3f !important;
}
.bg-error {
    background-color: #ff9f9e !important;
}
</style>



// WEBPACK FOOTER //
// Form.vue?5e66cefc